<!--
 * @Author: Nie Wie
 * @Date: 2020-03-04 20:09:52
 * @LastEditors: Nie Wie
 * @LastEditTime: 2020-06-12 10:14:18
 * @Description: 每周一图，后续确定使用单图模式还是双图模式
 -->
<template>
  <div class="weekimg-part">
    <part-title title="蓦然回首"></part-title>
    <div class="weekimg--descript">
      <span>{{title}}</span>
    </div>
    <!-- 只有一个图 -->
    <div class="weekimg__container"
        @pointermove.stop.prevent="mousemove"
        v-show="beforeImgUrl && afterImgUrl"
      >
      <div class="weekimg__img-out">
        <div class="weekimg__before-title">{{afterImgTitle}}</div>
        <img :src="afterImgUrl" alt="">
      </div>
      <div class="weekimg__img-out2" :style="{
        'width': firstWidth,
        'background-image': `url(${beforeImgUrl})`,
      }">
        <div class="weekimg__after-title">{{beforeImgTitle}}</div>
        <div class="weekimg__justfy-bar">
          <div :class="['weekimg__justfy-btn', {
            'weekimg__justfy-btn-mobile': isMobile,
          }]"
            @touchstart.stop.prevent="touchStart"
            @mousedown="allowPan = true">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PartTitle from '@/components/part-title'
import {
  WEEK_IMG_URL,
  WEEK_IMG_ACTIVE,
} from '@/assets/const-value/interface'

import img1Next from '@/assets/week-imgs/43-20170509.jpg'
import img2Next from '@/assets/week-imgs/43-20201002.jpg'

export default {
  components: {
    PartTitle,
  },
  data() {
    return {
      firstWidth: '340px',
      allowPan: false,
      title: '正在获取 ... ',
      beforeImgTitle: '',
      afterImgTitle: '',
      beforeImgUrl: null,
      afterImgUrl: null,
    }
  },
  computed: {
    showOldWeek() {
      return !(window.location.host === '49.4.114.251' || window.location.hostname === 'localhost')
    },
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
  },
  mounted() {
    this.$nextTick(() => {
      document.body.addEventListener('touchend', this.touchEnd)
      document.body.addEventListener('mouseup', this.touchEnd)
      this.getActiveImg()
    })
  },
  methods: {
    async getActiveImg() {
      const { data: activeData } = await this.$axios.get(WEEK_IMG_ACTIVE)
      // 等待更新测试，
      if (!activeData || !activeData.length) {
        return
      }
      const activeItem = this.showOldWeek ? activeData.find(x => x.preStatus) : activeData.find(x => x.testStatus)
      if (activeItem) {
        const before = await this.$axios.get(WEEK_IMG_URL, { params: { fileId: activeItem.qsxImageId } }) // qsx   title  hsxImageId  hsx
        const after = await this.$axios.get(WEEK_IMG_URL, { params: { fileId: activeItem.hsxImageId } }) // qsx   title  hsxImageId  hsx
        if (before.data && after.data) {
          this.title = activeItem.title
          this.beforeImgTitle = activeItem.qsx
          this.afterImgTitle = activeItem.hsx
          this.beforeImgUrl = before.data
          this.afterImgUrl = after.data
        } else {
          this.showErrorImg()
        }
      } else {
        this.showErrorImg()
      }
    },
    // 当数据请求失败时候，显示默认图片
    showErrorImg() {
      this.title = '大连永兴岛恒力石化产业园'
      this.beforeImgTitle = '20170509'
      this.afterImgTitle = '20201002'
      this.beforeImgUrl = img1Next
      this.afterImgUrl = img2Next
    },
    mousemove(e) {
      if (this.allowPan) {
        const left = e.clientX - e.currentTarget.offsetLeft
        this.firstWidth = left < 680 ? `${left}px` : '680px'
      }
    },
    touchStart(ev) {
      ev.preventDefault()
      if (ev.touches.length === 1) {
        // this.startX = ev.touches[0].clientX // 记录开始位置
        this.allowPan = true
      }
    },
    touchEnd() {
      this.allowPan = false
    },
  },
}
</script>

<style lang="scss">
body {
  height: unset;
}
.weekimg-part {
  padding: 0 35px;
}
.weekimg--descript {
  margin-top: -25px;
  padding: 15px;
  text-align: center;
  font-size: 28px;
  font-family: PingFangSC-Medium,PingFang SC;
  font-weight: 500;
  color: #666;
}
.weekimg__container {
  position: relative;
  font-size: 0;
  img {
    width: 100%;
    border-radius: 12px;
  }
}
.weekimg__img-out {
  width: 100%;
  pointer-events: none;
}
.weekimg__img-out2 {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: auto 100%;
  border-radius: 12px 0px 0px 12px;
}
.weekimg__before-title {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 0 4px;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  font-size: 16px;
  font-family: PingFangSC-Regular,PingFang SC;
  font-weight: 400;
  color: #fff;
  background-color: #197DF4;
  border-radius: 4px;
  z-index: 7;
}
.weekimg__after-title {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 0 4px;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  font-size: 16px;
  font-family: PingFangSC-Regular,PingFang SC;
  font-weight: 400;
  color: #fff;
  background-color: #197DF4;
  border-radius: 4px;
  z-index: 7;
}
.weekimg__justfy-bar {
  float: right;
  height: 100%;
  width: 3px;
  background: rgb(122, 135, 162); // #197DF4;
  // transform: translateX(2px);
}
.weekimg__justfy-btn {
  position: absolute;
  top: 49%;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  background-image: url(../../../assets/images/drag.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  transform: translateX(-12px);
  &:hover {
    cursor: pointer;
  }
}
.weekimg__justfy-btn-mobile {
  width: 40px;
  height: 40px;
  transform: translateX(-18px);
}
</style>
